import {BotData} from '../../../../../../api/types';
import styles from './ActiveMemories.module.css';
import {CommonDialog} from '../CommonDialog/CommonDialog';
import {Memories, MemoryMessage} from '../MemoryMessage/MemoryMessage';
import {InButton} from '../../../../../../common-lib/src/components';
import {useContext, useEffect, useState} from 'react';
import {BotMemories, useMemories} from '../BotsMemories/BotMemories';
import {CV4RMemory} from '../../../../../../common-lib/src/api/Api.types';
import {webEventsApi} from '../../../../../../amplitude/webEvents';
import {AppContext} from '../../../../../../App';
import {Message} from '../../../../../../common-lib/src/api/Api';
import {prepareObjForAnalitics} from '../utils';

type Props = {
	bot: BotData;
	memory: CV4RMemory[];
	onClose: () => void;
	message?: Message;
};

const title = 'Active memories';
export const ActiveMemories = ({bot, onClose, memory, message}: Props) => {
	return (
		<CommonDialog title={title} onClose={onClose}>
			<ActiveMemoriesInner
				bot={bot}
				onClose={onClose}
				memory={memory}
				message={message}
			/>
		</CommonDialog>
	);
};

const ActiveMemoriesInner = ({bot, onClose, memory, message}: Props) => {
	const [isAllMemoriesOpen, setIsAllMemoriesOpen] = useState(false);
	const {user} = useContext(AppContext);
	useEffect(() => {
		webEventsApi.messageMemoryAppear(
			prepareObjForAnalitics(bot, user, message)
		);
	}, []);

	const {handleEdit, handleDelete} = useMemories({
		bot,
		message,
		source: 'message_memory',
	});

	return (
		<div className={styles.container}>
			<Memories
				memory={memory}
				handleEdit={handleEdit}
				handleDelete={handleDelete}
			/>
			<InButton
				id="all-memories"
				className={styles.allMemoriesButton}
				onClick={() => setIsAllMemoriesOpen(true)}
			>
				All memories
			</InButton>
			{isAllMemoriesOpen && (
				<BotMemories
					bot={bot}
					onClose={() => setIsAllMemoriesOpen(false)}
					message={message}
				/>
			)}
		</div>
	);
};
